import BaseMystery from '../BaseMystery'

const FirstJoyfulMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/a/andrea/sarto/3/the_annu.jpg",
		"https://www.wga.hu/art/a/allori/alessand/annuncia.jpg",
		"https://www.wga.hu/art/a/alesso/annuncia.jpg",
		"https://www.wga.hu/art/a/albani/1/annuncia.jpg",
		"https://www.wga.hu/art/a/andrea/sarto/1/annuncia.jpg",
		"https://www.wga.hu/art/a/angelico/04/1annunc1.jpg",
		"https://www.wga.hu/art/a/angelico/12/40annunc.jpg",
		"https://www.wga.hu/art/a/angelico/09/cells/03_annun.jpg",
		"https://www.wga.hu/art/a/antoline/jose/annuncia.jpg",
		"https://www.wga.hu/art/b/barocci/annuncia.jpg",
		"https://www.wga.hu/art/b/barocci/annuncix.jpg",
		"https://www.wga.hu/art/b/bartolom/fra/annuncia.jpg",
		"https://www.wga.hu/art/b/beccafum/2/8annunci.jpg",
		"https://www.wga.hu/art/b/beer/annuncia.jpg",
		"https://www.wga.hu/art/b/beer/virgin2.jpg",
		"https://www.wga.hu/art/b/bellini/gentile/annuncia.jpg",
		"https://www.wga.hu/art/b/bellini/jacopo/birth1.jpg",
		"https://www.wga.hu/art/b/bellini/jacopo/annuncia.jpg",
		"https://www.wga.hu/art/b/berrugue/pedro/annuncia.jpg",
		"https://www.wga.hu/art/b/betti/annuncia.jpg",
		"https://www.wga.hu/art/b/boccacci/boccacci/1/cremona2.jpg",
		"https://www.wga.hu/art/b/bonfigli/annunci.jpg",
		"https://www.wga.hu/art/b/bonfigli/annuncia.jpg",
		"https://www.wga.hu/art/b/bor/annuncia.jpg",
		"https://www.wga.hu/art/b/bordone/annuncia.jpg",
		"https://www.wga.hu/art/b/botticel/22/81cestel.jpg",
		"https://www.wga.hu/art/b/botticel/22/6annunci.jpg",
		"https://www.wga.hu/art/c/caccia/guglielm/annuncia.jpg",
		"https://www.wga.hu/art/c/camilo/annuncia.jpg",
		"https://www.wga.hu/art/c/carneval/2annunc2.jpg",
		"https://www.wga.hu/art/c/champaig/philippe/annunci1.jpg",
		"https://www.wga.hu/art/c/cigoli/annuncia.jpg",
		"https://www.wga.hu/art/c/cima/1/04annun.jpg",
		"https://www.wga.hu/art/c/cleve/joos/annuncia.jpg",
		"https://www.wga.hu/art/c/coxcie/michiel/annuncia.jpg",
		"https://www.wga.hu/art/c/curradi/annuncia.jpg",
		"https://www.wga.hu/art/d/daddi/theannun.jpg",
		"https://www.wga.hu/art/d/david/2/annuncib.jpg",
		"https://www.wga.hu/art/e/ezquerra/cycle2.jpg",
		"https://www.wga.hu/art/g/garofalo/annunci.jpg",
	];

	const scriptureQuote = "Then the angel said to her, \"Do not be afraid, Mary, for you have found favor with God. Behold, you will conceive in your womb and bear a son, and you shall name him Jesus.\"";
	const scriptureCitation = "Luke 1:30-31 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Luke%201%3A26-38&version=NABRE";

	return (
		<BaseMystery titleText="The Annunciation"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default FirstJoyfulMystery;